// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3.0043 1.59007L3.00017 1.58594L1.58594 3.00013L6.51395 7.92826L10 12.8174V21H14V15.4145L20.9997 22.4144L22.4097 21.0045L3 1.59437L3.0043 1.59007Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.27 11.0362L21 3H7.23399L15.27 11.0362Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-filter-off-filled')
export default class FilterOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-off-filled',
    }
  }
}
